import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzPaginationI18nInterface } from "ng-zorro-antd/i18n";
import { NzPaginationDefaultComponent } from "ng-zorro-antd/pagination";
import { PaginationItemRenderContext } from "../../pagination.models";

@Component({
  selector: "ui-pagination-default",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "pagination-default.component.html",
})
export class UiPaginationDefaultComponent extends NzPaginationDefaultComponent {
  @ViewChild("containerTemplate", { static: true }) public template!: TemplateRef<NzSafeAny>;
  @Input("uiSize") public nzSize: "default" | "small" = "default";
  @Input("itemRender") public itemRender: TemplateRef<PaginationItemRenderContext> | null = null;
  @Input("showTotal") public showTotal: TemplateRef<{ $implicit: number; range: [number, number] }> | null = null;
  @Input("disabled") public disabled = false;
  @Input("locale") public locale!: NzPaginationI18nInterface;
  @Input("showSizeChanger") public showSizeChanger = false;
  @Input("showQuickJumper") public showQuickJumper = false;
  @Input("total") public total = 0;
  @Input("pageIndex") public pageIndex = 1;
  @Input("pageSize") public pageSize = 10;
  @Input("pageSizeOptions") public pageSizeOptions: number[] = [10, 20, 30, 40];
  // Design wants no tooltips in the custom reflection paginator implementation
  // This is a workaround to disable it as NgZorro doesn't have an API to control that.
  @Input("uiShowTooltip") @InputBoolean() public showTooltip = true;
  @Output("pageIndexChange") public readonly pageIndexChange = new EventEmitter<number>();
  @Output("pageSizeChange") public readonly pageSizeChange = new EventEmitter<number>();
}
